import { inject, Pipe, PipeTransform } from '@angular/core';
import { MenuItemType } from '@common/components/app-header/app-header-item.model';
import { RoutePath } from '@common/enums';
import { AuthContextService } from '@common/services/auth/auth-context.service';
import { I18NextPipe } from 'angular-i18next';

@Pipe({
  name: 'activeRoute',
  pure: true
})
export class ActiveRoutePipe implements PipeTransform {
  private readonly authContext = inject(AuthContextService);
  private readonly i18nPipe = inject(I18NextPipe);

  private readonly reportingDropdownPages: MenuItemType[] = [
    {
      name: this.i18nPipe.transform('header.dropdown.backupHistory', { format: 'capitalize' }),
      routeUrl: RoutePath.BackupHistory,
      iconClass: 'fa fa-edit',
      id: this.i18nPipe.transform('header.dropdown.backupHistory', { format: 'capitalize' })
    },
    {
      name: this.i18nPipe.transform('header.dropdown.history', { format: 'capitalize' }),
      routeUrl: RoutePath.History,
      iconClass: 'fa fa-history',
      id: this.i18nPipe.transform('header.dropdown.history', { format: 'capitalize' })
    },
    {
      name: this.i18nPipe.transform('header.dropdown.reports', { format: 'capitalize' }),
      routeUrl: RoutePath.Reports,
      iconClass: 'ico ico-Excel',
      id: this.i18nPipe.transform('header.dropdown.reports', { format: 'capitalize' })
    },
    {
      name: this.i18nPipe.transform('header.dropdown.auditLog', { format: 'capitalize' }),
      routeUrl: RoutePath.AuditLog,
      iconClass: 'fa fa-book',
      id: this.i18nPipe.transform('header.dropdown.auditLog', { format: 'capitalize' })
    },
    {
      name: this.i18nPipe.transform('header.dropdown.exportResults', { format: 'capitalize' }),
      routeUrl: RoutePath.ExportResults,
      iconClass: 'fa fa-download',
      id: this.i18nPipe.transform('header.dropdown.exportResults', { format: 'capitalize' })
    },
    {
      name: this.i18nPipe.transform('header.dropdown.skipItems', { format: 'capitalize' }),
      routeUrl: RoutePath.SkipItems,
      iconClass: 'fa fa-list-alt',
      id: this.i18nPipe.transform('header.dropdown.skipItems', { format: 'capitalize' })
    }
  ];

  transform(routeUrl: string): MenuItemType {
    const firstUrlSegment = this.getUrlSegment(routeUrl.replace(this.authContext.prefix(), '/'));

    return this.reportingDropdownPages.find((item) => item.routeUrl === firstUrlSegment);
  }

  private getUrlSegment = (url: string): string => {
    const FIRST_URL_SEGMENT_REGEX = new RegExp('^/[^/]+', 'i');
    return FIRST_URL_SEGMENT_REGEX.test(url) ? url.replace(/^\/([^/]*).*$/, '$1') : null;
  };
}
